import { useEffect, useState } from 'react';
import { schedulingActions, getTreatmentCodes } from './helper';
import Item from './Item';
import { connect } from 'react-redux';
import { AppointmentActions } from 'store/actions';
import toast from 'react-hot-toast';

let enhancer = connect(null, { ...AppointmentActions });

const Actions = ({ treatmentPlan, onClose, onSchedule, isLoadable, fetchAppointments, getPatientAppointments }) => {
  const [selectedAction, setSelectedAction] = useState('scheduled');
  const [patientAppointments, setPatientAppointments] = useState(null);

  useEffect(() => {
    if (isLoadable) loadPatientAppointments();
  }, [isLoadable]);

  const loadPatientAppointments = async () => {
    setPatientAppointments(null);
    try {
      const { data } = await getPatientAppointments(
        { page: 1, appointments_by_codes: getTreatmentCodes(treatmentPlan?.treatments?.data) });

      setPatientAppointments(data)
    } catch (error) {
      toast.error(error.errors || 'Failed to load patient appointments');
    }
  };


  const loadAppointments = async () => {
    setPatientAppointments(null)
    try {
      const { data } = await fetchAppointments();
      setPatientAppointments(data)
    } catch (error) {
      toast.error(error.errors || 'Failed to load appointments');
    }
  };

  return (
    <div className="px-6 mt-4">
      <h3 className="text-xs font-bold text-secondary-900 mb-3">Admin Action</h3>

      <div className="space-y-3">
        {schedulingActions.map((schedulingAction) => (
          <Item
            key={schedulingAction.id}
            schedulingAction={schedulingAction}
            selectedAction={selectedAction}
            setSelectedAction={setSelectedAction}
            onClose={onClose}
            treatmentPlan={treatmentPlan}
            patientAppointments={patientAppointments}
            onRefresh={(() => loadAppointments())}
            onSchedule={onSchedule}
          />
        ))}
      </div>
    </div>
  )
}

export default enhancer(Actions)
